import type { FindAllASTEntitiesResponseType } from 'src/api/generated/touring/types';
import { mapTicketSalesAstEntityType } from './helpers';
import type { FindAllTicketSalesASTEntitiesType } from './types';

export const mapFindAllTicketSalesASTEntitiesResponseType = (
  api: FindAllASTEntitiesResponseType
): FindAllTicketSalesASTEntitiesType =>
  api.data.map(mapTicketSalesAstEntityType);
